import React from 'react';
import { FaRuler, FaEye, FaStar } from 'react-icons/fa';

const BuyingGuide = () => {
  return (
    <div className="py-16 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Buying <span className="text-orange-500">Guide</span></h1>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <div className="space-y-8">
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <div className="flex items-center gap-4 mb-4">
              <FaRuler className="text-3xl text-orange-500" />
              <h2 className="text-xl font-semibold text-gray-800">Frame Size</h2>
            </div>
            <p className="text-gray-600">Measure your current glasses or use our frame size guide. Common sizes: Narrow (115-125mm), Medium (125-135mm), Wide (135-145mm), Extra Wide (145-155mm).</p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-6">
            <div className="flex items-center gap-4 mb-4">
              <FaEye className="text-3xl text-orange-500" />
              <h2 className="text-xl font-semibold text-gray-800">Lens Types</h2>
            </div>
            <p className="text-gray-600">Choose from single vision, progressive, blue cut, photochromic, or polarized lenses based on your needs.</p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-6">
            <div className="flex items-center gap-4 mb-4">
              <FaStar className="text-3xl text-orange-500" />
              <h2 className="text-xl font-semibold text-gray-800">Materials</h2>
            </div>
            <p className="text-gray-600">Acetate, metal, stainless steel, titanium, TR90 – each offers different durability and weight.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyingGuide;